import { getCollectionById } from '~api/CollectionsAPI/CollectionsAPI';
import { _updateReplenishment } from '~api/ReplenismentAPI/handlers/ReplenishmentHandler';
import {
    reduceReplenishmentFrequency,
    reduceReplenishmentInfo
} from '~api/ReplenismentAPI/reducers/replenishmentReducers';

import { IUpdateReplenishmentPayload } from '~api/ReplenismentAPI/IReplenishmentAPI';
import { ICollection, IPGResponse } from '~api/CartAPI/ICartApiSdk';

export const getReplenishmentFrequencyByCollectionId = async (collectionId: string) => {
    const responses = await getCollectionById(collectionId);

    const res =
        responses.data?.find(
            ({ result }) => result.value.collection.COLLECTION_ID.toString() === collectionId
        ) || ({} as IPGResponse<ICollection>);

    return reduceReplenishmentFrequency(res);
};

export const updateReplenishment = async (payload: IUpdateReplenishmentPayload) => {
    const res = await _updateReplenishment(payload);
    const { collectionId } = reduceReplenishmentInfo(res);

    return { collectionId };
};
